import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { FormattedDate } from 'components/intl'
import { FormDataLoader } from 'components/loaders'
import { Title } from 'components/misc'
import getActivityClassName from 'helpers/dashboard/getActivityClassName'
import styles from './overview.styl'

export default class Overview extends Component {
  static propTypes = {
    title: PropTypes.any,
    content: PropTypes.array,
    noWrap: PropTypes.bool,
    loadingEnable: PropTypes.bool,
    activityOverview: PropTypes.object,
    activitySection: PropTypes.string,
    compact: PropTypes.bool,
    noIconSpace: PropTypes.bool,
    titleKey: PropTypes.string
  }

  static defaultProps = {
    hideBar: false,
    noWrap: false,
    loadingEnable: true,
    column: false,
    compact: false,
    noIconSpace: false,
  }

  renderText = item => {
    if (item.date) {
      return item.content && <FormattedDate value={item.content} />
    }
    return item.content
  }

  renderItem = (item, i) => {
    return (<div key={i} className={[styles.content, this.props.noIconSpace ? styles.contentCompact : ''].join(' ')}>
      <p className={styles.text}>
        {this.renderText(item) || '---'}
      </p>
      <p className={styles.caption}>
        {item.intlKey
          ? <FormattedMessage
              id={item.intlKey}
              defaultMessage={item.label}
          />
          : item.label}
      </p>
    </div>)
  }

  renderRow = (row, i) => {
    const isArray = Array.isArray(row)
    const isHidden = (isArray ? row.some(v => v && v.hide) : row && row.hide)
    const icon = (isArray ? row[0].ico : row && row.ico)

    return (row && !isHidden &&
      <div key={i} className={[styles.box, this.props.compact ? styles.boxCompact : ''].join(' ')}>
        <i className={`ico ico--${icon} ${styles.icon}`} />
        {isArray ? row.map((v, i) => this.renderItem(v, i)) : this.renderItem(row)}
      </div>)
  }

  render() {
    const {
      activityOverview,
      activitySection,
      title,
      content,
      noWrap,
      compact,
      titleKey,
      loadingEnable
    } = this.props

    const loading = get(activityOverview, 'loading') && loadingEnable

    const classNames = [styles[getActivityClassName(activitySection)]]

    !noWrap && classNames.push(styles.wrap)

    return !loading
      ? <div className={classNames.join(' ')}>
        {!compact && <Title h3 className={styles.heading} intlKey={titleKey}>
          {title}
        </Title>}
        {content && Array.isArray(content) && content.map(this.renderRow)}
      </div>
      : <FormDataLoader />
  }
}
